export const PARTICIPANT_TYPES = Object.freeze({
  'SINGLE': 'SINGLE',
  'GROUP': 'GROUP',
  'TEAM': 'TEAM'
})

export const PARTICIPANT_TYPE_OPTIONS = Object.freeze([
  {
    label: "Add a single person or account owner",
    value: PARTICIPANT_TYPES.SINGLE
  },
  { 
    label: "Round robin within a group",
    value: PARTICIPANT_TYPES.GROUP
  },
  {
    label: "Round robin within a team",
    value: PARTICIPANT_TYPES.TEAM
  },
])



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantActions/constants.js